module.exports = __webpack_public_path__ + "static/check.b352f4c4e977c92d7b636c2cf778e91d.svg";